const styles = theme => ({
  btnSave: {
    marginRight: theme.spacing(1),
  },
  file: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1) / 2,
  },
  fileContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  inputFile: {
    display: 'none',
  },
  buttonFile: {
    marginRight: theme.spacing(1),
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: theme.spacing(1),
  },
  image: {
    paddingTop: theme.spacing(1) / 2,
    paddingBottom: theme.spacing(1) / 2,
    paddingRight: theme.spacing(1) / 2,
    width: 'auto',
    height: '100px',
  },
  imageList: {
    listStyle: 'none',
  },
})

export default styles
